(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holyseek-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    document.querySelectorAll('.hk-shop-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
    if (event.target.closest('.hk-shop-mobile a')) {
      event.target.closest('.hk-shop-mobile').open = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    const details = active.closest?.('.hk-products-menu[open], .hk-shop-mobile[open]');
    if (details) {
      details.open = false;
      details.querySelector('summary').focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holyseek-product-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('holyseek-film-player')) {
    customElements.define('holyseek-film-player', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.video = this.querySelector('video');
        this.cover = this.querySelector('[data-film-cover]');
        this.button = this.querySelector('[data-film-play]');
        this.image = this.querySelector('img');
        if (!this.video || !this.cover || !this.button || !this.image) return;
        this.lifecycle = new AbortController();
        const options = { signal: this.lifecycle.signal };
        this.cover.hidden = !this.video.paused && this.video.readyState >= 3;
        this.button.addEventListener('click', () => this.startPlayback(), options);
        this.video.addEventListener('playing', () => {
          const moveFocus = document.activeElement === this.button;
          this.cover.hidden = true;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          if (moveFocus) this.video.focus({ preventScroll: true });
        }, options);
        this.video.addEventListener('error', () => this.restoreCover(), options);
        this.video.addEventListener('ended', () => this.restoreCover(), options);
        this.image.addEventListener('error', () => this.useFallbackImage(), options);
        if (this.image.complete && this.image.naturalWidth === 0) this.useFallbackImage();
      }

      disconnectedCallback() {
        if (this.lifecycle) this.lifecycle.abort();
        this.lifecycle = null;
        if (this.button) {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }

      async startPlayback() {
        const lifecycle = this.lifecycle;
        if (!lifecycle || this.button.disabled) return;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.video.ended) this.video.currentTime = 0;
        try {
          await this.video.play();
        } catch (error) {
          if (this.lifecycle === lifecycle) this.restoreCover();
        } finally {
          if (this.lifecycle === lifecycle) {
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          }
        }
      }

      restoreCover() {
        this.cover.hidden = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }

      useFallbackImage() {
        const fallback = this.image.dataset.fallback;
        if (!fallback || this.image.dataset.fallbackUsed === 'true') return;
        this.image.dataset.fallbackUsed = 'true';
        this.image.src = fallback;
        this.video.poster = fallback;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holyseek-shop-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('holyseek-shop-slider')){
    customElements.define('holyseek-shop-slider',class extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector('[data-slider-track]');
        this.slides=Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.dots=Array.from(this.querySelectorAll('[data-slider-go]'));
        if(!this.track||!this.slides.length)return;
        this.events=new AbortController();
        const options={signal:this.events.signal};
        this.index=0;
        this.querySelector('[data-slider-previous]')?.addEventListener('click',()=>this.go(this.index-1),options);
        this.querySelector('[data-slider-next]')?.addEventListener('click',()=>this.go(this.index+1),options);
        this.dots.forEach(dot=>dot.addEventListener('click',()=>this.go(Number(dot.dataset.sliderGo)),options));
        this.track.addEventListener('scroll',()=>{
          cancelAnimationFrame(this.frame);
          this.frame=requestAnimationFrame(()=>{
            const width=this.track.clientWidth;
            if(width)this.update(Math.round(this.track.scrollLeft/width));
          });
        },{passive:true,signal:this.events.signal});
        this.addEventListener('keydown',event=>{
          if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
          if(event.target.matches('input,textarea,select'))return;
          event.preventDefault();
          this.go(this.index+(event.key==='ArrowRight'?1:-1));
        },options);
        this.addEventListener('shopify:block:select',event=>{
          const selected=event.target.closest('[data-slider-slide]');
          const next=this.slides.indexOf(selected);
          if(next>=0)this.go(next,true);
        },options);
        this.resize=new ResizeObserver(()=>this.go(this.index,true));
        this.resize.observe(this.track);
        this.update(0);
      }
      go(index,instant=false){
        const next=(index+this.slides.length)%this.slides.length;
        const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({left:this.track.clientWidth*next,behavior:instant||reduce?'instant':'smooth'});
        this.update(next);
      }
      update(index){
        this.index=Math.min(Math.max(index,0),this.slides.length-1);
        this.slides.forEach((slide,i)=>{
          const active=i===this.index;
          slide.inert=!active;
          slide.setAttribute('aria-hidden',String(!active));
        });
        this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
      }
      disconnectedCallback(){this.events?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
